<template>
    <form class="col-md-12 mx-auto" @submit.prevent="onSave">
        <div class="card border-primary mb-3" :id="'participantsEditCard' + _uid">
            <h5 class="card-header text-primary" v-for="fullName in fullNames" :key="fullName">
                <i class="fas fa-user-edit mr-2"></i>
                {{fullName}}
            </h5>
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox v-model="model.editPositionStatistic">
                            {{ $t('registers.events.participants.editor.editPositionStatistic') }}
                        </vs-checkbox>
                    </div>
                    <div v-if="model.editPositionStatistic" class="form-group col-6">
                        <label class="font-weight-bold" :for="'positionStatisticId' + _uid">
                            {{ $t('registers.events.participants.gridHeaders.positionStatistic') }}
                        </label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="positionStatisticSort"
                            v-model="model.positionStatisticId"
                            :fieldName="$t('registers.events.participants.gridHeaders.positionStatistic')"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                        ></dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox v-model="model.editPosition">
                            {{ $t('registers.events.participants.editor.editPosition') }}
                        </vs-checkbox>
                    </div>
                    <div v-if="model.editPosition" class="form-group col-6">
                        <label class="font-weight-bold" :for="'positionId' + _uid">
                            {{ $t('registers.events.participants.gridHeaders.position') }}
                        </label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="positionSort"
                            v-model="model.positionId"
                            :fieldName="$t('registers.events.participants.gridHeaders.position')"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                        ></dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox v-model="model.editEducationDegree">
                            {{ $t('registers.events.participants.editor.editEducationDegree') }}
                        </vs-checkbox>
                    </div>
                    <div v-if="model.editEducationDegree" class="form-group col-6">
                        <label class="font-weight-bold" :for="'educationDegreeId' + _uid">
                            {{ $t('registers.events.participants.gridHeaders.educationDegree') }}
                        </label>
                        <dropdown
                            :loadByParentSort="true"
                            :parentSort="educationDegreeSort"
                            v-model="model.educationDegreeId"
                            :fieldName="$t('registers.events.participants.gridHeaders.educationDegree')"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                        ></dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox v-model="model.editInstitutionRegister">
                            {{ $t('registers.events.participants.editor.editInstitutionRegister') }}
                        </vs-checkbox>
                    </div>
                    <div v-if="model.editInstitutionRegister" class="form-group col-6">
                        <label class="font-weight-bold" :for="'institutionRegisterId' + _uid">
                            {{ $t('registers.events.participants.gridHeaders.institutionNomenclature') }}
                        </label>
                        <dynamic-dropdown
                            :apiUrl="`/api/institution/dropdownModel/false`"
                            v-model="model.institutionRegisterId"
                            :id="'institutionRegisterId' + _uid"
                            :name="'institutionRegisterId' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.institutionNomenclature')"
                            :filter="'contains'"
                            :clear-button="true"
                            :autoWidth="true"
                            :height="400"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                        ></dynamic-dropdown>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox
                            v-model="model.editParticipationType"
                        >{{$t('registers.events.participants.editor.editParticipationType')}}</vs-checkbox>
                    </div>
                    <div v-if="model.editParticipationType" class="form-group col-6">
                        <label
                            class="font-weight-bold required"
                            :for="'participationType' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.participationType")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/participationType/getDropdownModels`"
                            v-model="model.participationTypeId"
                            :id="'participationType' + _uid"
                            :name="'participationType' + _uid"
                            :fieldName="$t('registers.events.participants.gridHeaders.participationType')"
                            :height="500"
                            :required=model.editParticipationType
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                            aria-describedby="participationTypeHelp"
                        ></dynamic-dropdown>
                        <small
                            id="participationTypeHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.participationType")}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox
                            v-model="model.editRelationType"
                        >{{$t('registers.events.participants.editor.editRelationType')}}</vs-checkbox>
                    </div>
                    <div v-if="model.editRelationType" class="form-group col-6">
                        <label
                            class="font-weight-bold"
                            :for="'ralationType' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.relationType")}}</label>
                        <dynamic-dropdown
                            ref="participationRelationType"
                            :apiUrl="`/api/participationRelationType/getDropdownModels`"
                            v-model="model.relationTypeId"
                            :id="'ralationType' + _uid"
                            :name="'ralationType' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.relationType')"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                            aria-describedby="relationTypeHelp"
                        ></dynamic-dropdown>
                        <small
                            id="relationTypeHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.relationType")}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox
                            v-model="model.editReasonForAdmission"
                        >{{$t('registers.events.participants.editor.editReasonForAdmission')}}</vs-checkbox>
                    </div>
                    <div v-if="model.editReasonForAdmission" class="form-group col-6">
                        <label
                            class="font-weight-bold"
                            :for="'reasonForAdmission' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.reasonForAdmission")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/reasonForAdmission/getDropdownModels`"
                            v-model="model.reasonForAdmissionId"
                            :id="'reasonForAdmission' + _uid"
                            :name="'reasonForAdmission' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.reasonForAdmission')"
                            :height="500"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                            aria-describedby="reasonForAdmissionHelp"
                        ></dynamic-dropdown>
                        <small
                            id="reasonForAdmissionHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.reasonForAdmission")}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox
                            v-model="model.editStatus"
                        >{{$t('registers.events.participants.editor.editStatus')}}</vs-checkbox>
                    </div>
                    <div v-if="model.editStatus" class="form-group col-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationStatus' + _uid"
                        >{{$t("registers.events.participants.gridHeaders.status")}}</label>
                        <dynamic-dropdown
                            :apiUrl="`/api/participant/participationStatusesDropdownSource`"
                            v-model="model.statusId"
                            :id="'participationStatus' + _uid"
                            :name="'participationStatus' + _uid"
                            :required="false"
                            :fieldName="$t('registers.events.participants.gridHeaders.status')"
                            :height="500"
                            :bindPopup="true"
                            :popupContainerId="'#participantsEditCard' + _uid"
                            aria-describedby="participationStatusHelp"
                        ></dynamic-dropdown>
                        <small
                            id="participationStatusHelp"
                            class="form-text text-muted"
                        >{{$t("registers.events.participants.help.participationStatus")}}</small>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-6">
                        <vs-checkbox
                            v-model="model.editNote"
                        >{{$t('registers.events.participants.editor.editNote')}}</vs-checkbox>
                    </div>
                    <div v-if="model.editNote" class="form-group col-6">
                        <label
                            class="font-weight-bold"
                            :for="'note' + _uid"
                        >{{$t('registers.events.participants.gridHeaders.note')}}</label>
                        <textarea
                            class="form-control"
                            rows="5"
                            v-model="model.note"
                            :name="'note' + _uid"
                            :id="'note' + _uid"
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="text-right mt-3">
                <div class="btn-group" role="group" aria-label="Person edit buttons">
                    <button type="button" class="btn btn-success" :disabled="saving" @click.stop="onSave">
                        <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                        <i v-else class="fas fa-save"></i>
                        {{$t('buttons.save.btnText')}}
                    </button>
                    <button type="button" class="btn btn-danger" :disabled="saving" @click.stop="onCancel">
                        <i class="fas fa-ban"></i>
                        {{$t('buttons.cancel')}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import { ParticipantsUpdateModel } from '../../models/models';
    import participantService from "../../services/participant.service";
    import DynamicDropdown from "../../components/dropdown/DynamicDropdown";
    import Dropdown from "../../components/dropdown/NomenclatureDropdown";
    import { NomenclatureParentBySort } from "../../models/enums";

    export default {
        inject: ["$validator"],
        props: {
            value: {
                type: ParticipantsUpdateModel,
                required: false,
            }
        },
        components: {
            DynamicDropdown,
            Dropdown
        },
        data() {
            return {
                model: this.value,
                saving: false,
                positionStatisticSort: NomenclatureParentBySort.PositionStatistic,
                positionSort: NomenclatureParentBySort.Position,
                educationDegreeSort: NomenclatureParentBySort.EducationDegree,
            };
        },
        computed: {
            fullNames() {
                return this.model.participantNames;
            },
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = new ParticipantsUpdateModel(this.value);
                }
            },
        },
        methods: {
            onSave() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.updateMultiple();
                    }
                });
            },
            updateMultiple() {
                this.saving = true;

                participantService
                    .updateMultiple(this.model)
                    .then((response) => {
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                    this.$helpers.responseStatusCode(response)
                            ),
                            text: this.$helpers.responseMessage(response),
                            color: "success",
                            time: this.$store.getters.notificationDuration,
                        });

                        this.$emit("save", this.model);
                    })
                    .catch((error) => {
                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                    this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    })
                    .then(() => { this.saving = false; });
            },
            onCancel(e) {
                this.$emit("cancel", e);
            }
        }
    };
</script>

<style scoped>
    .con-vs-checkbox {
        justify-content:left;
    }
</style>
